module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-15-fc7054372d1c20d147605386a16cb0e0.png";